import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { toastV4Error } from '../services/edulead-v4';
import { eduleadV4 } from '../services/edulead-v4-client';

export const useCopyExport = () => {
  const navigate = useNavigate();
  const [isCopying, setIsCopying] = useState(false);

  const copyExport = async (exportId: string) => {
    setIsCopying(true);
    try {
      const { export: copy } = await eduleadV4.exports.create({
        request_id: crypto.randomUUID(),
        export: { copied_from_export_id: exportId }
      });
      toast.success('Export copied successfully');
      navigate(`/exports/${copy?.id}/target`);
    } catch (err) {
      toastV4Error(err, 'Failed to copy export');
    } finally {
      setIsCopying(false);
    }
  };

  return { copyExport, isCopying };
};
